import React from 'react'

export const Footerup = () => {
  return (
    <div>
        <div className='like'>
        <h1>Do you like this awesome WordPress theme?</h1>
        <button className='btn5'>Download Now</button>
        </div>


       </div>
  )
}
